export var ToastTypeEnum;
(function (ToastTypeEnum) {
    ToastTypeEnum[ToastTypeEnum["none"] = 0] = "none";
    ToastTypeEnum[ToastTypeEnum["success"] = 1] = "success";
    ToastTypeEnum[ToastTypeEnum["danger"] = 2] = "danger";
    ToastTypeEnum[ToastTypeEnum["warn"] = 3] = "warn";
    ToastTypeEnum[ToastTypeEnum["info"] = 4] = "info";
    ToastTypeEnum[ToastTypeEnum["permanent"] = 5] = "permanent";
})(ToastTypeEnum || (ToastTypeEnum = {}));
export var ToastPositionEnum;
(function (ToastPositionEnum) {
    ToastPositionEnum[ToastPositionEnum["bottom"] = 0] = "bottom";
    ToastPositionEnum[ToastPositionEnum["top"] = 1] = "top";
})(ToastPositionEnum || (ToastPositionEnum = {}));
export const flushToasterNone = {
    type: ToastTypeEnum.none,
    title: '',
    message: '',
};
